import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import useSignOut from "hooks/user/useSignOut";
import signout from "icons/solid/right-from-bracket.svg";

import { MenuClass } from "./UserMenuLink";

export default function MenuSignOut() {
  const { signOut } = useSignOut();

  return (
    <button type="button" className={MenuClass} onClick={signOut}>
      <Icon
        icon={signout}
        className="text-gray-400 group-hover/link:text-indigo-300"
      />
      <Text>Sign Out</Text>
    </button>
  );
}
